import universal from 'react-universal-component';

export SearchMap from './SearchMap';
export const Map = universal(import(/* webpackChunkName: "Map" */'./Map'));
